import React from "react";
import { Heading } from "@chakra-ui/react";
export function UpsellHeading(props) {
    return React.createElement(Heading, { fontFamily: "upsell", color: "space", ...props });
}
